import { render, staticRenderFns } from "./GlAcctNoHelpList2.vue?vue&type=template&id=b2d9c236&"
import script from "./GlAcctNoHelpList2.vue?vue&type=script&lang=js&"
export * from "./GlAcctNoHelpList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports